import api from './api';

export type OptionEventType = 'Viewed' | 'Selected' | 'Carted';
export type ItemType = 'Art' | 'Product' | 'CustomPrint';

export const trackOptionEvent = async (payload: {
  itemType: ItemType;
  itemId?: number;
  artReproductionId?: number;
  productId?: number;
  size?: string;
  material?: string;
  finish?: string;
  eventType: OptionEventType;
}): Promise<void> => {
  try {
    await api.post('/metrics/events', payload);
  } catch {
    // ignore tracking failures
  }
};
